/* eslint-env jquery */
(function ($) {
  if ($('.projects').length) {
    $(document).ready(projectsInit);
  }

  function projectsInit() {
    projects();
  }

  function projects() {
    const loadMoreHolder = $('.load-more-btn');
    const loadMoreBtn = document.querySelector('#load-more-btn');
    const tileGroup = $('.tile-group');
    const currentItem = tileGroup.attr('data-count');
    const total = tileGroup.attr('data-total');
    if (loadMoreHolder.length) {
      if (Number.parseInt(total, 10) > Number.parseInt(currentItem, 10)) {
        loadMoreHolder.removeClass('d-none');
      }

      loadMoreBtn.addEventListener('click', () => {
        $('.projects .tile-holder').removeClass('invisible mb-0');
        $('.projects .tile-holder').removeAttr('style');
        loadMoreHolder.remove();
      });
    }
  }
})(jQuery);
